import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { SPECIFIED_WORKS, japaneseOrdinal } from '@/consts/regular_health_checkup/specified_work';
import type { Schema } from '../../schema';

export const SpecifiedWorkSummaries: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>労働安全衛生規則第13条第１項第３号に掲げる業務に従事する労働者数</Headding>
      <Item>
        {SPECIFIED_WORKS.map(({ code, label }, index) => (
          <div key={code} className={classNames({ 'u-mt20': index > 0 })}>
            <Label>
              {japaneseOrdinal(index)}　{label}
            </Label>
            <Spacer size={8} />
            <Input {...register(`specifiedWorkSummaries.${code}.count`)} />
            {errors.specifiedWorkSummaries?.[code]?.count?.message && (
              <ErrorMessage>{errors.specifiedWorkSummaries?.[code]?.count.message}</ErrorMessage>
            )}
          </div>
        ))}
      </Item>
    </Panel>
  );
};
